(function () {
  "use strict";

  function init() {
    const productJson = document.querySelector("[data-product-json]");
    if (!productJson) return;

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      return;
    }

    const options = product.options;
    const genderIdx = options.findIndex((o) => o.toLowerCase() === "gender");
    const sizeIdx = options.findIndex((o) => o.toLowerCase() === "size");
    if (genderIdx === -1 || sizeIdx === -1) return;

    const genderKey = "option" + (genderIdx + 1);
    const sizeKey = "option" + (sizeIdx + 1);

    // Pre-compute: { "Youth": Set("S","M","L"), "Adult": Set("M","L","XL") }
    // Done ONCE — no repeated array filtering on every interaction.
    const sizeMap = Object.create(null);
    const variants = product.variants;
    for (let i = 0, len = variants.length; i < len; i++) {
      const v = variants[i];
      const g = v[genderKey];
      if (!sizeMap[g]) sizeMap[g] = new Set();
      sizeMap[g].add(v[sizeKey]);
    }

    const genderFieldset = document.querySelector(
      '[data-variant-option][data-variant-option-index="' + genderIdx + '"]'
    );
    const sizeFieldset = document.querySelector(
      '[data-variant-option][data-variant-option-index="' + sizeIdx + '"]'
    );
    if (!genderFieldset || !sizeFieldset) return;

    // Cache size wrappers + their inputs ONCE
    const sizeNodes = [];
    const wrappers = sizeFieldset.querySelectorAll(
      "[data-variant-option-value-wrapper]"
    );
    for (let i = 0; i < wrappers.length; i++) {
      const wrapper = wrappers[i];
      const input = wrapper.querySelector("[data-variant-option-value]");
      if (input) sizeNodes.push({ wrapper, input, value: input.value });
    }

    let rafId = null;
    let lastGender = null;

    function apply() {
      rafId = null;
      const checked = genderFieldset.querySelector(
        "[data-variant-option-value]:checked"
      );
      const gender = checked ? checked.value : null;
      if (!gender || gender === lastGender) return;
      lastGender = gender;

      const validSet = sizeMap[gender];
      if (!validSet) return;

      let firstVisible = null;
      let stillValid = false;

      for (let i = 0, len = sizeNodes.length; i < len; i++) {
        const node = sizeNodes[i];
        const isValid = validSet.has(node.value);
        const wrapper = node.wrapper;
        const input = node.input;

        // Only touch DOM if state actually changes
        const currentlyHidden = wrapper.style.display === "none";
        if (isValid && currentlyHidden) {
          wrapper.style.display = "";
          input.disabled = false;
        } else if (!isValid && !currentlyHidden) {
          wrapper.style.display = "none";
          input.disabled = true;
          if (input.checked) input.checked = false;
        }

        if (isValid) {
          if (!firstVisible) firstVisible = input;
          if (input.checked) stillValid = true;
        }
      }

      if (!stillValid && firstVisible) {
        firstVisible.checked = true;
        firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    function schedule() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(apply);
    }

    // Single delegated listener instead of one per radio
    genderFieldset.addEventListener("change", schedule);

    // Initial run
    apply();
  }

  // Defer until idle so it doesn't block initial render
  function start() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(init, { timeout: 500 });
    } else {
      setTimeout(init, 0);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", init);
})();
